import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import SubHeader from "../../../../components/SubHeader";
import RolesAndPermissionsList from "./RolesAndPermissionsList";
import styles from "./style";

const RolesAndPermissionsPage = ({ data,handleSearch,page,total,setPage,handleSort,getRolesPermissionsList }) => {
  const theme = useTheme();
  //   const {showAlert} = useAlert();

  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={styles.leaveHeading}>User Management</Typography>


      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader
          search={true}
          sortBy={true}
          handleSort={handleSort}
          onchange={(text) => handleSearch(text)}
          onCompanyChange={getRolesPermissionsList}
        // isShowFilter={true}
        /> 
        <RolesAndPermissionsList data={data} setPage={setPage} page={page} total={total}/>

      </Box>
    </>
  );
};

export default RolesAndPermissionsPage;
